
import { Vue, Component, Prop } from "nuxt-property-decorator"
import { PROPERTY_TYPES, PROPERTY_TYPE_LIST } from "~/constants/listing"

@Component
export default class PropertyTypeSelect extends Vue {
  @Prop({ type: String }) value: string | null
  @Prop({ type: String, default: "" }) error: string
  @Prop({ type: String, default: "" }) label: string
  @Prop({ type: String, default: "" }) backgroundColor: string
  @Prop({ type: String, default: "" }) iconColor: string
  @Prop({ type: Number, default: null }) iconSize: number | null
  @Prop({ type: Number, default: null }) iconPadding: number | null
  @Prop({ type: Boolean, default: true }) border: boolean
  @Prop({ type: Boolean, default: true }) indicator: boolean

  @Prop({
    type: Array,
    default() {
      return []
    }
  })
  iconLeft

  @Prop({
    type: Array,
    default() {
      return []
    }
  })
  iconRight

  // "xs", "s", "m", "l"
  @Prop({ type: String, default: "m" }) size: string

  isOpen: boolean = false
  xPadding: number | null = null
  propertyTypes: any[] = PROPERTY_TYPES

  mounted() {
    if (this.iconLeft.length >= 2 || this.iconRight.length >= 2) {
      if (this.iconPadding) {
        this.xPadding = this.iconPadding
      } else {
        this.xPadding = this.iconSize ? this.iconSize * 2 : this.iconFontSize() * 2
      }
    }
  }

  get propertyTypeLabel() {
    return (
      PROPERTY_TYPE_LIST.find(pType => pType.value === this.value)?.name || "Select Property Type"
    )
  }

  close() {
    this.isOpen = false
  }

  iconFontSize() {
    let size = 16

    if (this.iconSize) {
      size = this.iconSize
    } else {
      switch (this.size) {
        case "xs":
          size = 16
          break
        case "s":
          size = 18
          break
        case "m":
          size = 20
          break
        case "l":
          size = 24
          break
      }
    }

    return size
  }

  iconStyles(): Array<string> {
    const styles: Array<string> = []

    if (this.iconLeft.length >= 2 || this.iconRight.length >= 2) {
      styles.push(`width: ${this.xPadding}px`)
    }

    if (this.iconColor) {
      styles.push(`color: ${this.iconColor}`)
    }

    return styles
  }

  styles(): Array<string> {
    const styles: Array<string> = []

    if (this.iconLeft.length >= 2) {
      styles.push(`padding-left: ${this.xPadding}px`)
    }

    if (this.iconRight.length >= 2) {
      styles.push(`padding-right: ${this.xPadding}px`)
    }

    if (!this.border) {
      styles.push(`border: 0`)
    }

    if (this.backgroundColor) {
      styles.push(`background-color: ${this.backgroundColor}`)
    }

    return styles
  }
}
